var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { NavigationItem } from "@atlassiansox/microscopekit";
import DiscoverFilledIcon from '@atlaskit/icon/glyph/discover-filled';
// These links show up in the navigation sidebar for urls starting with `/services/{service_name}`
var MyServiceNavigation = /** @class */ (function (_super) {
    __extends(MyServiceNavigation, _super);
    function MyServiceNavigation() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MyServiceNavigation.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement(NavigationItem, { icon: React.createElement(DiscoverFilledIcon, { label: "Credo" }), text: "Credo", href: "/services/" + encodeURIComponent(this.props.id) + "/credo" })));
    };
    return MyServiceNavigation;
}(React.Component));
export { MyServiceNavigation };
